module.exports = __webpack_public_path__ + "static/media/ic_ct_black.48b3b861.svg";